import useTestId from '@ori/testid-generator';
import { CheckCircle } from '@ori-ui/icons';
import type { FC } from 'react';
import React from 'react';

import { THANKS } from './constants';
import { Header, IconWrap, Root, TextInfo } from './styles';
import { useTranslations } from '../../hooks';
import { BackInStockNotificationChannel, TranslationKey } from '../../models';

export interface ThanksProps {
  currentType: BackInStockNotificationChannel;
}

export const Thanks: FC<ThanksProps> = ({ currentType }) => {
  const { getTestId } = useTestId();
  const { formatMessage, translations } = useTranslations();

  return (
    <Root data-testid={getTestId(THANKS)}>
      <IconWrap>
        <CheckCircle fontSize="inherit" />
      </IconWrap>
      <Header>{translations.thankYou}</Header>
      <TextInfo>
        {formatMessage(TranslationKey.notifyMeSuccess, {
          0: currentType === BackInStockNotificationChannel.Email ? translations.email : translations.sms,
        })}
      </TextInfo>
    </Root>
  );
};
